import App from '../../components/App/app';
import * as s from '../../../../../home24-shared/components/quickview/constants/selectors';
import cnSwiper from '../../../../../home24-shared/components/quickview/constants/classNames-swiper';
import { getArticleData } from '../../../../../home24-shared/components/quickview/functions/getArticleData';
import { addAllListener } from '../addAllListeners';
import { removeEventlistenerPictures } from '../eventListeners/pictures';
import { removeEventListenerToOptions } from '../eventListeners/options';
import { removeEventListenerToBuyButton } from '../../../../../home24-shared/components/quickview/functions/eventListeners/buy';
import {
  alternativeDIVprovider,
  alternativeDIV2Provider
} from '../../../../../home24-shared/components/quickview/functions/helpers/helpers';
import {
  DATA,
  SELECTEDSKUATTRIBUTE
} from '../../../../../home24-shared/components/quickview/constants/selectors';

export const empty = (selector, selector2, selector3) => {
  const el =
    document.querySelector(selector) ||
    document.getElementById(selector) ||
    document.getElementById(selector2) ||
    document.getElementById(selector3);
  el.innerHTML = '';
};

export const fill = (selector, selector2, selector3, div) => {
  const el =
    document.querySelector(selector) ||
    document.getElementById(selector) ||
    document.getElementById(selector2) ||
    document.getElementById(selector3);
  el.innerHTML = div;
};

export function initalRender(data, selector, selector2, selector3) {
  empty(selector, selector2, selector3);
  const div = App({
    data
  });
  fill(selector, selector2, selector3, div);
}

export function reRender(selectedChildSku) {
  document
    .getElementById(DATA)
    .setAttribute(SELECTEDSKUATTRIBUTE, selectedChildSku);
  const articleData = getArticleData();
  removeEventlistenerPictures();
  removeEventListenerToOptions();
  removeEventListenerToBuyButton(s.BUYBUTTON);
  initalRender(
    articleData,
    `.${cnSwiper.WRAP}`,
    alternativeDIVprovider(),
    alternativeDIV2Provider()
  );
  addAllListener(articleData);
}

export default initalRender;



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/components/quickview/functions/render/render.js
 **/